import { GenericAbortSignal } from 'axios';
import { doorClient, ImResponse, resolve } from '.';

export interface OfferParams {
  storeId: string;
  offerId: string;
  messageId: string;
}

export function offer(params: OfferParams, signal?: GenericAbortSignal) {
  return resolve(
    doorClient.get<ImResponse<Conversation.Offer>>('/aggregation/v1/getOfferDetail', {
      params,
      signal,
    }),
  );
}

export interface UpdateOfferStatusBody {
  storeId: string;
  offerId: string;
  messageId: string;
  operation: 'accepted' | 'rejected';
}

export const updateOfferStatusApi = '/aggregation/v1/setOfferStatus';

export function updateOfferStatus(body: UpdateOfferStatusBody) {
  return doorClient.post(updateOfferStatusApi, body);
}
